import { apiFetch, readApiJson } from '@/lib/api-fetch'
import {
  AttributionActionSchema,
  AttributionApplySchema,
  AttributionPreviewSchema,
  ProductEvidenceSchema,
  type AttributionAction,
  type AttributionApply,
  type AttributionPreview,
  type ProductEvidence,
} from '@/lib/api/schemas/product-attribution.schema'

export async function getProductAttributionEvidence(productId: string, signal?: AbortSignal): Promise<ProductEvidence> {
  return ProductEvidenceSchema.parse(await readApiJson(await apiFetch(`/api/product-attribution/products/${encodeURIComponent(productId)}/evidence`, { signal })))
}

export async function previewAttributionActions(actions: readonly AttributionAction[]): Promise<AttributionPreview> {
  const normalized = actions.map((action) => AttributionActionSchema.parse(action))
  return AttributionPreviewSchema.parse(await readApiJson(await apiFetch('/api/product-attribution/actions/preview', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ actions: normalized }) })))
}

export class AttributionActionError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'AttributionActionError'
    this.status = status
  }
}

export async function applyAttributionActions(actions: readonly AttributionAction[], previewDigest: string): Promise<AttributionApply> {
  const normalized = actions.map((action) => AttributionActionSchema.parse(action))
  const response = await apiFetch('/api/product-attribution/actions/apply', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ actions: normalized, previewDigest }) })
  if (!response.ok) {
    let message = 'Исправление атрибуции не применено.'
    try {
      const body: unknown = await response.clone().json()
      if (typeof body === 'object' && body !== null && 'detail' in body) {
        const detail = body.detail
        if (typeof detail === 'string') message = detail
        else if (typeof detail === 'object' && detail !== null && 'message' in detail && typeof detail.message === 'string') message = detail.message
      }
    } catch {
      // Keep the bounded Russian transport fallback.
    }
    throw new AttributionActionError(response.status, message)
  }
  return AttributionApplySchema.parse(await readApiJson(response))
}
